import React from "react";

const Revenue = () => {
  return <h1>Revenue</h1>;
};

export default Revenue;
